<template>
  <div>
    <modal id="create-contact">
      <template slot="header">Link Existing User To Vendor</template>
      <div class="form-group">
        <input
          type="email"
          v-model="emailName"
          class="form-control"
          placeholder="Email Address, First or Last Name"
        />
        <ul class="list-group" v-if="filteredUsers.length > 0">
          <li
            class="cursor-pointer list-group-item"
            v-for="user in filteredUsers"
            :key="user.id"
            @click="selectUser(user)"
          >
            <i class="fas fa-user mr-1"></i>
            {{ user.name }}
            <span class="float-right text-muted small">({{ user.email }})</span>
          </li>
        </ul>
      </div>
      <div class="form-group d-flex">
        <label>Primary Contact</label>
        <div class="custom-control custom-switch ml-4">
          <input
            type="checkbox"
            class="custom-control-input"
            id="customSwitch_primary_contact"
            v-model="primaryContact"
          />
          <label
            class="custom-control-label"
            for="customSwitch_primary_contact"
          >
            <badge type="pill" :color="primaryContact ? 'success' : 'danger'">
              <span
                v-html="
                  primaryContact
                    ? `<i class='fas fa-check fa-fw'></i> Yes`
                    : `<i class='fas fa-times fa-fw'></i> No`
                "
              ></span>
            </badge>
          </label>
        </div>
      </div>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="attachContact"
        >
          <span v-if="!saving">Save</span>
          <span
            class="spinner-border spinner-border-sm"
            v-if="saving"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-secondary"
          data-dismiss="modal"
        >
          Close
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "CreateContact",
  props: {
    vendor: {
      type: Number,
      required: true,
    },
    reset: Number,
    contacts: {
      require: false,
    },
  },
  data() {
    return {
      selectedUser: null,
      primaryContact: false,
      emailName: "",
    };
  },
  watch: {
    reset: function () {
      this.selectedUser = null;
      this.primaryContact = false;
      this.emailName = "";
    },
  },
  computed: {
    ...mapState(["saving", "user", "users"]),
    filteredUsers: function () {
      if (this.emailName == "") {
        return [];
      } else {
        return this.searchableUsers.filter((u) => {
          return (
            u.email.toLowerCase().startsWith(this.emailName.toLowerCase()) ||
            u.name.toLowerCase().indexOf(this.emailName.toLowerCase()) > -1
          );
        });
      }
    },
    searchableUsers: function () {
      if (this.contacts && this.contacts.length) {
        const contactsIds = this.contacts.map((contact) => contact.user_id);
        return this.users.searchableUsers.filter(
          (user) => !contactsIds.includes(user.id)
        );
      }
      return this.users.searchableUsers;
    },
  },
  mounted() {
    this.$store.dispatch("users/getUsersForSearch");
  },
  methods: {
    selectUser: function (user) {
      this.selectedUser = user;
      this.emailName = user.name;
    },
    attachContact: function () {
      if (!this.selectedUser) {
        return Swal.fire({
          title: "Error",
          text: "No user selected!",
          type: "error",
        });
      }
      this.$store.commit("SET_SAVING_STATE", true);
      this.$store.dispatch("contacts/attachUserToVendor", {
        vendor: this.vendor,
        contact: this.selectedUser.id,
        primaryContact: this.primaryContact,
      });
    },
  },
};
</script>
